// extracted by mini-css-extract-plugin
export default {"form":"ResponsiveLayout-module__form__cSymG"};